module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-home ccm-page page-template-full"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), _c('Header'), (_vm.props && !_vm.loading) ? _c('main', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 address-in-all",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.add_address_top)
    }
  })])]), _c('div', {
    staticClass: "ccm-image-slider-container ccm-block-image-slider-pages"
  }, [_c('div', {
    staticClass: "ccm-image-slider"
  }, [_c('div', {
    staticClass: "ccm-image-slider-inner"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.props.acf.add_slider), function(slidermain) {
    return _c('swiper-slide', {
      key: _vm.i,
      staticClass: "slide-1"
    }, [_c('img', {
      attrs: {
        "src": slidermain.url,
        "alt": slidermain.alt
      }
    })])
  }), _c('div', {
    staticClass: "swiper-pagination swiper-pagination-white",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 2)], 1)])]), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h1', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "30px"
    }
  }, [_c('span', {
    staticClass: "title-thin"
  }, [_vm._v(_vm._s(_vm.props.acf.title_section_one))])])])])]), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "ccm-custom-style-container ccm-custom-style-main3-4106 feature-home-page"
  }, [_c('div', {
    staticClass: "ccm-block-feature-item"
  }, [_c('h4', [_c('i', {
    staticClass: "fa fa-flash"
  }), _vm._v(" " + _vm._s(_vm.props.acf.block_one_section_one.title))]), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.block_one_section_one.content)
    }
  })])])]), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "ccm-custom-style-container ccm-custom-style-main4-3652 feature-home-page"
  }, [_c('div', {
    staticClass: "ccm-block-feature-item"
  }, [_c('h4', [_c('i', {
    staticClass: "fa fa-heart-o"
  }), _vm._v(" " + _vm._s(_vm.props.acf.block_two_section_one.title))]), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.block_two_section_one.content)
    }
  })])])]), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "ccm-custom-style-container ccm-custom-style-main5-3368 feature-home-page"
  }, [_c('div', {
    staticClass: "ccm-block-feature-item"
  }, [_c('h4', [_c('i', {
    staticClass: "fa fa-arrow-circle-o-up"
  }), _vm._v(" " + _vm._s(_vm.props.acf.block_three_section_one.title))]), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.block_three_section_one.content)
    }
  })])])])])])])]), _vm._m(0), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    attrs: {
      "id": "Irvine orthodontics provider"
    }
  }, [_c('h2', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "30px"
    }
  }, [_c('span', {
    directives: [{
      name: "htm",
      rawName: "v-htm:P",
      value: (_vm.props.acf.title_seaction_two),
      expression: "props.acf.title_seaction_two",
      arg: "P"
    }],
    staticClass: "title-thin"
  })])])])])]), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "ccm-custom-style-container ccm-custom-style-main283-3642"
  }, [(_vm.props.acf.left_image_section_two) ? _c('picture', [_c('img', {
    staticClass: "ccm-image-block img-responsive bID-3642",
    attrs: {
      "src": _vm.props.acf.left_image_section_two.url,
      "alt": _vm.props.acf.left_image_section_two.alt
    }
  })]) : _vm._e()])]), _c('div', {
    staticClass: "col-sm-8",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.right_content_section_two)
    }
  })])])])]), _vm._m(1), _vm._m(2), _vm._m(3), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "ccm-custom-style-container ccm-custom-style-main-3641"
  }, [_c('div', {
    attrs: {
      "id": "reviews"
    }
  }, [_c('center', [_c('span', {
    staticClass: "title-thin"
  }, [_vm._v("Our Patients Love Us. Read Our Reviews...")])])], 1)])])])]), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.props.acf.add_our_reviews), function(review) {
    return _c('div', {
      staticClass: "col-sm-4"
    }, [_c('div', {
      staticClass: "HTMLBlock",
      attrs: {
        "id": "HTMLBlock5573"
      },
      domProps: {
        "innerHTML": _vm._s(review.add_reviews)
      }
    })])
  }))])])]), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_vm._m(4), _c('a', {
    attrs: {
      "aria-label": "fb",
      "href": _vm.props.acf.review_us.fb_link
    }
  }, [_c('picture', [_c('img', {
    staticClass: "ccm-image-block img-responsive bID-2211",
    attrs: {
      "src": _vm.props.acf.review_us.fb_image,
      "alt": "Facebook Reviews: Updike Orthodontics",
      "title": "Facebook Reviews: Updike Orthodontics"
    }
  })])]), _c('a', {
    attrs: {
      "aria-label": "google",
      "href": _vm.props.acf.review_us.google_link
    }
  }, [_c('picture', [_c('img', {
    staticClass: "ccm-image-block img-responsive bID-2212",
    attrs: {
      "src": _vm.props.acf.review_us.google_image,
      "alt": "Google Reviews: Updike Orthodontics"
    }
  })])]), _c('div', {
    staticClass: "HTMLBlock",
    attrs: {
      "id": "HTMLBlock3336"
    }
  }, [_c('div', {
    attrs: {
      "id": "yelp-biz-badge-rrc-QyMqgP33M-M8ECJGDHAd-g"
    }
  }, [_c('a', {
    attrs: {
      "aria-label": "yelp",
      "href": _vm.props.acf.review_us.yelp_link
    }
  }, [_c('img', {
    attrs: {
      "alt": "Updike Orthodontics",
      "src": _vm.props.acf.review_us.yelp_image,
      "height": "55",
      "width": "125"
    }
  })])]), _vm._m(5)])]), _c('div', {
    staticClass: "col-sm-4"
  }, [_vm._m(6), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.experienced_orthodontist.add_image)
    }
  })]), _c('div', {
    staticClass: "col-sm-6"
  }, [_vm._m(7), _c('h6', [_c('span', {
    staticClass: "image-caption"
  }, [_c('span', [_c('span', {
    staticClass: "title-caps",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.office_hours)
    }
  })])])]), _c('p'), _c('div', {
    staticClass: "saprater-mian"
  }), _c('p')])])])])])]) : _vm._e(), _c('Footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ccm-custom-style-container ccm-custom-style-main-3637"
  }, [_c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ccm-custom-style-container ccm-custom-style-main-3636"
  }, [_c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-home-videos"
  }, [_c('div', {
    staticClass: "custom-home-videos__title"
  }, [_vm._v("Video Testimonials")]), _c('div', {
    staticClass: "custom-home-videos__container"
  }, [_c('video', {
    staticClass: "custom-home-videos__video-one",
    attrs: {
      "src": "/static/testimonial-1.mp4",
      "controls": "controls"
    }
  }), _c('video', {
    staticClass: "custom-home-videos__video-two",
    attrs: {
      "src": "/static/testimonial-2.mp4",
      "controls": "controls"
    }
  }), _c('video', {
    staticClass: "custom-home-videos__video-three",
    attrs: {
      "src": "/static/testimonial-3.mp4",
      "controls": "controls"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ccm-custom-style-container ccm-custom-style-main-3636"
  }, [_c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ccm-custom-style-container ccm-custom-style-main75-3616"
  }, [_c('h4', [_c('span', {
    staticClass: "title-caps"
  }, [_vm._v("Review Us:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('span', {
    staticClass: "title-caps"
  }, [_vm._v("Experienced Orthodontist")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('span', {
    staticClass: "title-caps"
  }, [_vm._v("Office Hours:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c02f16ae","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/home/home.pug
// module id = 572
// module chunks = 1